import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Layout from "@/components/feature/Layout";
import Home from "@/pages/home/page";
import CharacterList from "@/pages/characters/page";
import CharacterDetail from "@/pages/characters/detail/page";
import VoiceActors from "@/pages/voice-actors/page";
import About from "@/pages/about/page";

const routes: RouteObject[] = [
  {
    element: <Layout />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/characters",
        element: <CharacterList />,
      },
      {
        path: "/characters/:id",
        element: <CharacterDetail />,
      },
      {
        path: "/voice-actors",
        element: <VoiceActors />,
      },
      {
        path: "/about",
        element: <About />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;